import { createContext, useContext } from 'react';
import { RootStoreMobX } from '../stores/root.store';
import { RootStoreContext as RootStoreCommonContext } from '@gimlite/common/hooks/useStore.hook';

export function useStoreUIV1() {
  const context = useContext(RootStoreContext);
  const contextCommon = useContext(RootStoreCommonContext);
  if (context === undefined) {
    throw new Error('useRootStore must be used within RootStoreProvider');
  }

  return { ...context, ...contextCommon };
}

export const RootStoreContext = createContext<RootStoreMobX | undefined>(
  undefined,
);
